import { Checkbox } from "../Checkbox/Checkbox";
import classNames from "classnames";
import { Table } from "react-table-8.10.7";

export const SelectionHeaderCell = <TData,>({
  table,
  className,
  ariaLabel = "Select all rows",
}: {
  table: Table<TData>;
  className?: string;
  ariaLabel?: string;
}) => {
  return (
    <div className={classNames("t-flex t-items-center", className)}>
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={(e) => {
          table.toggleAllRowsSelected(e.target.checked);
        }}
        aria-label={ariaLabel}
      />
    </div>
  );
};
